import { MENUITEM_DEFINITIONS } from '@/lib/constants';
import { MenuItemType } from '@/types';

// utility function so that we can keep DRY
export const buildMenuGroup = (ids: string[], overrides: Record<string, Partial<MenuItemType>> = {}): MenuItemType[] =>
    ids.map(
        id =>
            ({
                id,
                ...MENUITEM_DEFINITIONS[id],
                ...(overrides[id] || {}),
            }) as MenuItemType
    );
